import React from "react";

import { useHistory } from "react-router";
import { Grid } from "@material-ui/core";

import { useApp } from "../../contexts";
import {
  Wrapper,
  BgTriangulo,
  BgMais,
  BgRetangulo,
  BgCirculo,
  BgQuadrado,
} from "./styles";
import { IUsuarios } from "../../models";
import { CarregarDadosUsuario } from "../../servicos";
import Treino from "./Modos/Treino";
import Batalha from "./Modos/Batalha";
import Torneio from "./Modos/Torneio";
import Controles from "./Controles";
import VisaoGeral from "./VisaoGeral";

export default function Home() {
  const { usuario, setUsuarioCorrente, statusBatalhando } = useApp();
  const history = useHistory();
  const [modo, setModo] = React.useState(0);
  const [dadosUsuario, setDadosUsuario] = React.useState<IUsuarios>();

  // Carregar dados de usuário
  const carregarDadosUsuario = React.useCallback(async () => {
    if (usuario.email) {
      try {
        let dados = await CarregarDadosUsuario(usuario.email);
        setDadosUsuario(dados);
        setUsuarioCorrente(dados);
      } catch (err) {
        history.push("/");
      }
    } else {
      const verificaStorage = localStorage.getItem("@batalha-dev/autenticado");
      const dadosLocais = verificaStorage && JSON.parse(verificaStorage);
      try {
        let dados = await CarregarDadosUsuario(dadosLocais.email);
        setDadosUsuario(dados);
        setUsuarioCorrente(dados);
      } catch (err) {
        history.push("/");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    carregarDadosUsuario();
  }, [carregarDadosUsuario]);

  React.useEffect(() => {
    if (dadosUsuario && dadosUsuario.system.in_combat) {
      dadosUsuario.system.in_combat = false;
      setDadosUsuario(dadosUsuario);
      setUsuarioCorrente(dadosUsuario);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dadosUsuario]);

  function iniciarTreino(): void {
    if (dadosUsuario) {
      dadosUsuario.system.in_combat = false;
      setDadosUsuario(dadosUsuario);
      setUsuarioCorrente(dadosUsuario);
      setModo(1);
    }
  }

  function procurarBatalha(): void {
    if (dadosUsuario) {
      dadosUsuario.system.in_combat = false;
      setDadosUsuario(dadosUsuario);
      setUsuarioCorrente(dadosUsuario);
      setModo(2);
    }
  }

  function procurarTorneio(): void {
    if (dadosUsuario) {
      dadosUsuario.system.in_combat = false;
      setDadosUsuario(dadosUsuario);
      setUsuarioCorrente(dadosUsuario);
      setModo(3);
    }
  }

  function sairModoCorrente(): void {
    if (dadosUsuario) {
      setModo(0);
      dadosUsuario.system.in_combat = false;
      setDadosUsuario(dadosUsuario);
      setUsuarioCorrente(dadosUsuario);
    }
  }

  function carregaModalidade(): JSX.Element {
    if (modo === 0) return <VisaoGeral procurarTorneio={procurarTorneio} />;
    if (modo === 1) return <Treino fecharModo={sairModoCorrente} />;
    if (modo === 2) return <Batalha fecharModo={sairModoCorrente} />;
    if (modo === 3) return <Torneio fecharModo={sairModoCorrente} />;
    return <Grid>Modalidade não encontrada!</Grid>;
  }

  function backgroundAnimado(): JSX.Element {
    return (
      <>
        <BgTriangulo />
        <BgMais />
        <BgRetangulo />
        <BgCirculo />
        <BgQuadrado />
      </>
    );
  }

  return (
    <Wrapper>
      {backgroundAnimado()}
      <Grid
        container
        className={`body ${
          statusBatalhando ? "aumentaAltura" : "diminuiAltura"
        }`}
      >
        <Grid container item spacing={2}>
          <Grid container item>
            {carregaModalidade()}
          </Grid>
        </Grid>
      </Grid>
      <Controles
        iniciarTreino={iniciarTreino}
        procurarBatalha={procurarBatalha}
        procurarTorneio={procurarTorneio}
      />
    </Wrapper>
  );
}
